import Http from "./http";

export const canEvaluate = async () => {
  let data = await Http.get(`/classevaluation/canievaluate`);
  return data.data;
};

export const createClassEvaluation = async ({ rating, notes }) => {
  let data = await Http.post(`/classevaluation`, { rating, notes });
  return data.data;
};

export const getClassEvaluations = async ({ student_id }) => {
  let data = await Http.get(`/students/${student_id}/classevaluations`);
  return data.data;
};
